import { SearchAndSelectVehicle, VehicleSearchFiltersContextProvider } from '@makemydeal/dr-activities-change-vehicle';

export const SelectVehicleContainer = () => {
    return (
        <VehicleSearchFiltersContextProvider>
            <SearchAndSelectVehicle />
        </VehicleSearchFiltersContextProvider>
    );
};
